
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import SongChartClass, { SongChartEvent } from '../lib/SongChart';
import { BaseCurve } from '../lib/curves';

@Component
export default class SongChart extends Vue {
  @Prop() curve!: BaseCurve;

  @Prop({ default: 0 }) buffer!: number;

  @Prop({ default: 0 }) progress!: number;

  songChart!: SongChartClass;

  mounted() {
    this.songChart = new SongChartClass(this.$el as HTMLElement, this.curve);
    this.songChart.on(SongChartEvent.Update, (event) => {
      this.$emit('update', event);
    });
  }

  @Watch('buffer')
  onBufferUpdate(buffer: number) {
    this.songChart.setBuffer(buffer);
  }

  @Watch('progress')
  onProgressUpdate(progress: number) {
    this.songChart.setProgress(progress);
  }
}
